import React from 'react';
import { useLocation } from 'react-router-dom';
import { EvaluationLoad } from './EvaluationLoad';
const EvaluationLoadWrapper = (props) => {
  const location = useLocation();
  return <EvaluationLoad location={location} {...props} />;
};

export default EvaluationLoadWrapper;
